import React, { Component } from 'react';
import './_styles.scss';

class LayoutFourAddOn extends Component {
	constructor(props) {
	    super(props);
	}

	render() {
		const { groups: imagesAddOn = [] } = this.props || {};

		return (
			<div className="landing-comercial-4-addon landing-comercial-4-addon--flex">
				<div className="landing-comercial-4-addon__left">
					<div className="landing-comercial-4-addon__tile">
						<img className="landing-comercial-4-addon__img" src={imagesAddOn[0].images.large} alt="AddOn-1" />
                        <div className="landing-comercial-4-addon__overlay">
						    <span className="landing-comercial-4-addon__title">{imagesAddOn[0].title}</span>
                        </div>
					</div>
					<div className="landing-comercial-4-addon__tile">
						<img className="landing-comercial-4-addon__img" src={imagesAddOn[1].images.large} alt="AddOn-2" />
                        <div className="landing-comercial-4-addon__overlay">
						    <span className="landing-comercial-4-addon__title">{imagesAddOn[1].title}</span>
                        </div>
					</div>
					<div className="landing-comercial-4-addon__tile">
						<img className="landing-comercial-4-addon__img" src={imagesAddOn[2].images.large} alt="AddOn-3" />
                        <div className="landing-comercial-4-addon__overlay">
						    <span className="landing-comercial-4-addon__title">{imagesAddOn[2].title}</span>
                        </div>
					</div>
				</div>
				<div className="landing-comercial-4-addon__right">
					<img className="landing-comercial-4-addon__img" src={imagesAddOn[3].images.vertical} alt="AddOn-4" />
				</div>
			</div>
		);
	}
}
export default LayoutFourAddOn;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialAddOn/Components/LayoutFourAddOn/index.jsx